<template>
  <button
    :type="type"
    :class="[
      'ui button',
      semanticClass,
      color,
      { outlined: outlined },
      { width__auto: widthAuto },
      { bubble__button: bubbleButton },
    ]"
    :disabled="disabled"
  >
    <i v-if="icon" :class="['iconButton', icon]"></i>
    {{ label }}
  </button>
</template>

<script>
export default {
  props: {
    bubbleButton: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "trv-default",
      validator: (value) => {
        return (
          [
            "trv-default",
            "trv-primary",
            "trv-secondary",
            "trv-error",
            "trv-neutral",
          ].indexOf(value) !== -1
        );
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: String,
    label: String,
    toggleable: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    semanticClass: String,
    type: {
      type: String,
      default: "button",
      validator: (value) => {
        return ["button", "submit", "reset"].indexOf(value) !== -1;
      },
    },
    widthAuto: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ui.button {
  width: 100%;
  color: white;
  font-weight: 100;
  display: flex;
  justify-content: center;
  border: 1px solid;
}

.ui.button:disabled {
  cursor: not-allowed;
  background-color: var(--color-gray);
}

.ui.button.width__auto {
  width: auto;
}

.iconButton {
  margin-right: 0.5rem;
}

.ui.button.bubble__button {
  border-radius: 50%;
  height: 2.2rem;
  width: 2rem;
}
.ui.button.bubble__button .iconButton {
  margin-right: 0;
}

.trv-default,
.trv-default:hover,
.trv-default:focus
{
  background-color: rgb(var(--color-default));
}
.trv-primary,
.trv-primary:hover,
.trv-primary:focus
{
  background-color: rgb(var(--color-primary));
}
.trv-secondary,
.trv-secondary:hover,
.trv-secondary:focus 
{
  background-color: rgb(var(--color-secondary));
}
.trv-error,
.trv-error:hover,
.trv-error:focus  
{
  background-color: rgb(var(--color-error));
}
.trv-neutral,
.trv-neutral:hover,
.trv-neutral:focus
{
  background-color: rgb(var(--color-neutral));
  color: #777982 !important;

}

.outlined {
  background-color: white;
  transition: background-color 0.2s ease-in-out;
}

.outlined.trv-default {
  border: 1px solid rgb(var(--color-default));
  color: rgb(var(--color-default));
  background-color: white;
}
.outlined.trv-default:hover
/* ,.outlined.trv-default:focus */
{ 
  background-color: rgba(var(--color-default));
  color: white;
}

.outlined.trv-primary {
  border: 1px solid rgb(var(--color-primary));
  color: rgb(var(--color-primary));
  background-color: white;
}
.outlined.trv-primary:hover
/* ,.outlined.trv-primary:focus  */
{
  background-color: rgba(var(--color-primary));
  color: white;
}

.outlined.trv-secondary {
  border: 1px solid rgb(var(--color-secondary));
  color: rgb(var(--color-secondary));
}
.outlined.trv-secondary:hover
/* ,.outlined.trv-secondary:focus  */
{
  background-color: rgba(var(--color-secondary));
  color: white;
}

.outlined.trv-error {
  border: 1px solid rgb(var(--color-error));
  color: rgb(var(--color-error));
}
.outlined.trv-error:hover
/* ,.outlined.trv-error:focus  */
{
  background-color: rgba(var(--color-error));
  color: white;
}

.outlined.trv-neutral {
  border: 1px solid rgb(var(--color-neutral));
  color: rgb(var(--color-neutral));
  background-color: white;
}
.outlined.trv-neutral:hover
/* ,.outlined.trv-neutral:focus  */
{
  background-color: rgba(var(--color-neutral));
  color: white;
}
</style>
